{
  "comment": "M7 spec §2.1–§2.2 (S2 owns): the settlement thread's logs. Log shape: src/story/schemas.ts evidenceLogSchema (at most ~120 words or one table; form carries the fact). Ids are unique across every evidence file; this file's ids start 'settlement.'. Fixed first-hour hook (spec §2.2, S14 reads it by id): 'settlement.first_ruin' is the guaranteed fragment of the first First Rush colony ruin visited in M3 space. 'settlement.minute_50a' is the Settlement file's contents (item settlement_50a, Mission 4; PC-3: Hale kept it). 'settlement.extraction_clause' is the shared extraction clause (spec §7, S11; Hale's 'Show' log): its clause 9 text must match the M2 Lease Office Lessee Conduct Covenant seed. Lead systemHints: 'fr-colony' (any First Rush colony ruin) plus galaxy anchor kinds ('authority-seat', 'descendant-capital'). Claim words added here (tier 5 slots): parties 'authority', 'tethys'; causes 'natural_event'; considerations 'reopening_costs', 'survey_escrow', 'claims_dismissal'; names 'hale', 'anand'. Every name, code, place and date (CY = Charter Year; the Settlement is CY10 d290; colony 'Year n' counts from the gate going dark) is a placeholder until the naming pass. Canon guards (first-rush.md §6, §9): no conclusion stated, no counters, no Voss before tier 4, no Rush-pattern parts, no 'stripped the gate'. Repeatable corroboration (spec §2.5, the complicity link): 'settlement.corr_50a_extract' is Duarte's certified extract of 50-A (fee), or the Mutual archivist's registry copy if duarte_exposed; a template, slots {extract}, {clerk}, {day}.",
  "logs": [
    {
      "id": "settlement.first_ruin",
      "thread": "settlement",
      "link": "complicity",
      "kind": "proof",
      "weight": 1,
      "title": "FR-131 Ostry: colony log and survey buoy",
      "date": "Year 1 to CY60",
      "source": "frColonyRuin",
      "body": "Two records at the same ruin: the colony's own log, and the Charter survey buoy moored at its dock since the gate reopened.",
      "table": {
        "columns": [
          "Record",
          "Date",
          "Entry"
        ],
        "rows": [
          [
            "Colony log, first entry after the gate",
            "Year 1, d1",
            "Gate dark. 380 of us. Claim marker relit. Ice plant running."
          ],
          [
            "Colony log, last entry",
            "Year 31",
            "Fourteen left. Going to the Hold at spring. Leaving the lights on."
          ],
          [
            "Charter survey buoy",
            "CY60 d41",
            "No working operation. Claim lapsed CY10 under Commission minute 50-A, item 6. Open to new claimants."
          ],
          [
            "Buoy filed by",
            "CY60 d41",
            "Charter Authority registry, office of Commissioner Hale"
          ]
        ]
      },
      "words": [
        "authority",
        "hale"
      ]
    },
    {
      "id": "settlement.escrow_ledger",
      "thread": "settlement",
      "link": "complicity",
      "kind": "proof",
      "weight": 1,
      "title": "Account TMC-R 50-A, statement extract",
      "date": "CY59",
      "source": "derelictCore",
      "fromTier": 2,
      "body": "Tethys Mining Combine, treasury. Account TMC-R 50-A, opened under Commission minute 50-A. Statement extract recovered from survey tender TS-9.",
      "table": {
        "columns": [
          "Year",
          "Entry",
          "Amount (cr)"
        ],
        "rows": [
          [
            "CY10 d291",
            "Opening deposit: survey escrow",
            "40,000,000"
          ],
          [
            "CY11 to CY57",
            "Gate watch retainer, Gate Control",
            "3,100,000"
          ],
          [
            "CY58",
            "Gate survey and reopening costs",
            "29,400,000"
          ],
          [
            "CY59",
            "Registry fees: claims dismissal filings, 1,812 claims",
            "362,400"
          ],
          [
            "CY59",
            "Balance carried",
            "7,137,600"
          ]
        ]
      },
      "words": [
        "tethys",
        "survey_escrow",
        "reopening_costs",
        "claims_dismissal"
      ]
    },
    {
      "id": "settlement.extraction_clause",
      "thread": "settlement",
      "link": "complicity",
      "kind": "proof",
      "weight": 1,
      "title": "Clause 9, two documents",
      "date": "CY0 and CY60",
      "source": "authorityArchive",
      "fromTier": 4,
      "body": "Archive desk extract. Clause 9 of the first Frontier Charter beside clause 9 of the TCF Lessee Conduct Covenant, set out by the archive's text matcher. Matcher result: no differences.",
      "table": {
        "columns": [
          "Clause",
          "First Frontier Charter, CY0",
          "TCF Lessee Conduct Covenant, CY60"
        ],
        "rows": [
          [
            "9.1",
            "The holder shall extract at the rate the claim will bear.",
            "The holder shall extract at the rate the claim will bear."
          ],
          [
            "9.2",
            "Volume above plan earns a credit against dues.",
            "Volume above plan earns a credit against dues."
          ],
          [
            "9.3",
            "No survey finding shall suspend extraction without the holder's consent.",
            "No survey finding shall suspend extraction without the holder's consent."
          ],
          [
            "Review",
            "Deferred, minute 50-A, item 5",
            "None on file"
          ]
        ]
      }
    },
    {
      "id": "settlement.minute_50a",
      "thread": "settlement",
      "link": "complicity",
      "kind": "proof",
      "weight": 3,
      "title": "Commission minute 50-A",
      "date": "CY10 d290",
      "source": "missionItem",
      "item": "settlement_50a",
      "fromTier": 4,
      "body": "CHARTER AUTHORITY. COMMISSION ON THE REACH GATE CESSATION. Minute 50-A. SEALED. Present: Commissioners Anand, Vey, Holloway-Kerr; Tethys Mining Combine (counsel). Minute: Registry Officer Hale (jr). 3. Cause: the Commission accepts the finding of a natural event, per Tethys Survey Bulletin 11. 4. Costs: Tethys to carry the survey and reopening costs, from account TMC-R 50-A. 5. Charter clause 9 (extraction incentive): review deferred. 6. Claims by or for persons remaining in the Reach: pending contact. 7. Records: sealed. Destroy at CY20. Retention review: CY20 RETAIN. CY30 RETAIN. CY40 RETAIN. CY50 RETAIN. Reviewing officer: HALE.",
      "words": [
        "authority",
        "natural_event",
        "reopening_costs",
        "hale",
        "anand",
        "tethys"
      ]
    },
    {
      "id": "settlement.ruin_census",
      "thread": "settlement",
      "link": "none",
      "kind": "lead",
      "weight": 0,
      "title": "FR-104 Calder Ring, colony net roll call",
      "date": "Year 33",
      "source": "frColonyRuin",
      "body": "Roll call kept by the Calder Ring radio room on the colony net. Last page.",
      "table": {
        "columns": [
          "Colony",
          "Last heard",
          "Note"
        ],
        "rows": [
          [
            "FR-131 Ostry",
            "Year 30",
            "Fourteen left. Asking after seed stock."
          ],
          [
            "FR-150 Lacey Hab",
            "Year 22",
            "Gone to the Hold."
          ],
          [
            "FR-162 Wyck",
            "Year 9",
            "Trading water for filters."
          ],
          [
            "FR-175 Tarran Ring",
            "Year 4",
            "Silent since the fever."
          ],
          [
            "Calder Ring (us)",
            "Year 33",
            "Still here."
          ]
        ]
      },
      "lead": {
        "systemHint": "fr-colony",
        "poiKind": "ruin"
      }
    },
    {
      "id": "settlement.hab_claim_receipt",
      "thread": "settlement",
      "link": "none",
      "kind": "lead",
      "weight": 0,
      "title": "Claim of working operation, relay receipt",
      "date": "Year 2",
      "source": "frColonyRuin",
      "body": "Hab ring, Tollen Drift. Claim of working operation under the Frontier Charter, filed by the ring council. Proof attached: scrubber logs, 300 days; ice plant output; births 4, deaths 19. Sent by colony net to Gate Control for the registry. Receipt: UNDELIVERED, GATE DARK. Copy lodged with the Hold registry hall. Copy lodged again, Year 12. Again, Year 25.",
      "lead": {
        "systemHint": "descendant-capital",
        "poiKind": "station"
      }
    },
    {
      "id": "settlement.archive_relay_sheet",
      "thread": "settlement",
      "link": "none",
      "kind": "lead",
      "weight": 0,
      "title": "Mutual relay crew, archive maintenance sheet",
      "date": "CY60",
      "source": "mutualArchive",
      "fromTier": 3,
      "body": "SPACERS' MUTUAL, RELAY CREW 6. Maintenance sheet, archive relay, Charter seat. Slot: every sixth day, crew shuttle, service lock B. Sealed stacks, level 3: cooling fault on shelf S-50 again. Shelf holds Commission records, CY10, brought through when the gate reopened. Shelf seal is the Commissioner's personal seal. Not ours to open. Logged the fault, logged the seal, fixed the fan.",
      "lead": {
        "systemHint": "authority-seat",
        "poiKind": "station"
      }
    },
    {
      "id": "settlement.station_notice",
      "thread": "settlement",
      "link": "none",
      "kind": "official",
      "weight": 0,
      "title": "Charter Authority notice to settlements",
      "date": "CY10 d209",
      "source": "frColonyRuin",
      "body": "CHARTER AUTHORITY. NOTICE TO SETTLEMENTS IN THE REACH. Gate transit is suspended owing to a natural event in the gate field. Evacuation proceeds in the order posted by Gate Control. Settlements not called forward: remain, keep your operations working, await contact. The claims of persons remaining are protected under the Charter. Post this notice where every resident can read it.",
      "words": [
        "authority",
        "natural_event"
      ]
    },
    {
      "id": "settlement.pending_box",
      "thread": "settlement",
      "link": "none",
      "kind": "texture",
      "weight": 0,
      "title": "Registry box 112, claims pending",
      "date": "CY60 d12",
      "source": "authorityArchive",
      "fromTier": 4,
      "body": "Charter registry, sealed stacks. Box 112: claims of working operation received from the Hold registry hall. Held under minute 50-A, item 6. Label: PENDING CONTACT.",
      "table": {
        "columns": [
          "Claimant",
          "Site",
          "Proof",
          "Status"
        ],
        "rows": [
          [
            "L. Duarte, for the ring council",
            "hab ring, Tollen Drift",
            "scrubber logs, 300 days",
            "pending"
          ],
          [
            "Calder Ring council",
            "FR-104 Calder Ring",
            "ice plant output, 33 years",
            "pending"
          ],
          [
            "M. Grieve",
            "FR-131 Ostry",
            "colony log, 31 years",
            "pending"
          ],
          [
            "409 further claims",
            "",
            "",
            "pending"
          ]
        ]
      }
    },
    {
      "id": "settlement.corr_50a_extract",
      "thread": "settlement",
      "link": "complicity",
      "kind": "proof",
      "weight": 1,
      "title": "Minute 50-A, certified extract",
      "date": "CY60",
      "source": "authorityArchive",
      "fromTier": 4,
      "body": "CHARTER REGISTRY · CERTIFIED EXTRACT {extract}\nOf: Commission minute 50-A, CY10 d290, items 3 to 6\nItem 3: the Commission accepts the finding of a natural event.\nItem 4: Tethys to carry the survey and reopening costs.\nItem 5: Charter clause 9 (extraction incentive): review deferred.\nItem 6: claims of persons remaining: pending contact.\nCertified a true extract. Clerk: {clerk}. Issued {day}. Fee received.",
      "repeatable": true,
      "template": true
    }
  ]
}
